exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sideMenuContentFilmInfo--Title\n{\n    font-size: 22pt;\n    padding-bottom: 5%;\n    text-align: center;\n    font-style: italic;\n    color: rgb(255,255,255);\n}\n\n#sideMenuContentFilmInfo--pageTitle\n{\n    margin-top: 10%;\n    margin-left: 5%;\n    margin-right: 5%;\n}\n\n.sideMenuContentFilmInfo--Header\n{\n    font-weight: 600;\n}\n\n.sideMenuContentFilmInfo--Content\n{\n    padding-bottom: 5%;\n}\n\n.sideMenuContentFilmTags\n{\n    font-size: 14pt;\n    text-align: center;\n    margin-left: 4%;\n    margin-right: 4%;\n}\n\n.sideMenuContentFilmTags--Text\n{\n    color: rgb(220,220,220);\n/*    line-height: 2em;*/\n    text-decoration: none;\n    margin-bottom: 2vh;\n    display: block;\n}\n\n.sideMenuContentFilmTags > a:hover\n{\n    color: rgb(120,120,120);\n}\n\n.sideMenuContentDivingLine\n{\n    margin-right: 10%;\n    margin-left: 10%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/listSideMenu/listSideMenu.component.css
// module id = ../../../../../src/app/components/listSideMenu/listSideMenu.component.css
// module chunks = main